<template>
  <div :class="{ 'fixed-notification': fixed }">
    <AlertBanner 
      v-if="showAccountConfirmAlert"
      message="Письмо с подтверждением аккаунта отправлено на вашу электронную почту. Пожалуйста, перейдите по ссылке в письме, чтобы завершить регистрацию и затем выполните вход в аккаунт повторно."
      @close="closeAlert"
      :dark="dark"
      :showCloseButton="false"
    />
  </div>
</template>

<script>
import { defineComponent, ref } from 'vue'
import AlertBanner from './AlertBanner.vue'

export default defineComponent({
  name: 'SpecialOfferNotification',
  components: {
    AlertBanner
  },
  props: {
    dark: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      showAccountConfirmAlert: false,
      i: 0,
      // user_meta_data: {
      //   browser:'',browser_name:'',browser_version:'',browser_ua:'',
      //   os:'',ip:'',page:'',url:'',user_id:0,session_hash:'',
      //   anonymous_id:0,anonymous_hash:'',session_status:0,
      // }
    };
  },

  created() {
    if (this.$cookies.get("showAccountConfirmAlert") === "yes") {
      this.showAccountConfirmAlert = true;
    }
    this.generateRandom();
    // this.record_event();
  },

  methods: {
    generateRandom() {
      this.random_number = Math.floor(Math.random() * 10) + 1; //Bettween 1 and 10
      console.log('generate random ' + this.random_number)
    },
  },

  emits: ['close'],
  setup(props, { emit }) {
    const showAlert = ref(true)

    const closeAlert = () => {
      showAlert.value = false
      emit('close')
    }

    return {
      showAlert,
      closeAlert
    }

  }
})
</script>

<style scoped>
.fixed-notification {
  position: fixed;
  top: 100px; /* Positioned lower by another 15px */
  left: 0;
  right: 0;
  z-index: 9; /* Just below the header's z-index of 10 */
  padding: 0 16px; /* Add padding to match page layout */
}
</style>
